import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { HideShowAnimation } from './../../../shared/animations/HideShowAnimation';



@Component({
  selector: 'app-ani-flip',
  templateUrl: './ani-flip-example.component.html',
  styleUrls: ['./ani-flip-example.component.scss'],
  animations: [HideShowAnimation]
})
export class AniFlipExampleComponent implements OnInit {

  public _Loaded = false;
  protected ProfileData: any;
  protected ProfileIndex = 0;
  protected HidingIndex = 0;
  constructor(private http: HttpClient) { }
  
  ngOnInit() {
  this.LoadProfileData();
  }

  public LoadProfileData() {
    this.http.get('./../../../../../assets/profiles/scott.profile.flare.json')
        .subscribe(data => {
         this.ProfileData  = data;
         this.ProfileData.Profiles.forEach(element => {
           element.state = 'hide';
         });
         this.ProfileData.Profiles[this.ProfileIndex].state = 'show';
         this._Loaded = true;
         },
         error => {
           console.log('oops', error);
          }
        );
  }
  Next() {
    this.HidingIndex = this.ProfileIndex;
    this.ProfileData.Profiles[this.ProfileIndex].state = 'hide';
    if (this.ProfileIndex === this.ProfileData.Profiles.length - 1) {
          this.ProfileIndex = -1;
    }
    this.ProfileIndex++;
  }
  Prev(){
    this.HidingIndex = this.ProfileIndex;
    this.ProfileData.Profiles[this.ProfileIndex].state = 'hide';
    if(this.ProfileIndex === 0) {
      this.ProfileIndex = this.ProfileData.Profiles.length;
    }
    this.ProfileIndex--;
  }

  HidingStarted($event) {
    console.log(`${this.HidingIndex} animation ${$event.phaseName}`);
  }
  HidingComplete($event) {
    if ( this.HidingIndex !== this.ProfileIndex) {
      this.ProfileData.Profiles[this.ProfileIndex].state = 'show';
    }
  }
}
